module.exports = require("core-js/library/fn/json/stringify");